/**
 * Analizator składu karmy — porównuje do 4 składów side-by-side.
 *
 * Endpoint: POST /wp-json/hn/v1/analyze-composition (inc/compare.php)
 * → tablica { label, score, grade:{letter,label,color}, top3, pros[], cons[] }.
 * Config: window.hnAnalyzer { restUrl, nonce, maxItems, labels }.
 */

const CFG = window.hnAnalyzer || {};

function escHtml(value) {
    const div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
}

function escAttr(value) {
    return String(value == null ? '' : value).replace(/"/g, '&quot;');
}

export function initAnalyzer() {
    const formsWrap = document.querySelector('[data-hn-analyzer-forms]');
    if (!formsWrap) {
        return;
    }
    const addBtn = document.querySelector('[data-hn-analyzer-add]');
    const runBtn = document.querySelector('[data-hn-analyzer-run]');
    const resultsEl = document.querySelector('[data-hn-analyzer-results]');
    const maxItems = CFG.maxItems || 4;
    const endpoint = CFG.restUrl || '/wp-json/hn/v1/analyze-composition';

    function syncControls() {
        const items = formsWrap.querySelectorAll('[data-hn-analyzer-form]');
        items.forEach((item) => {
            const removeBtn = item.querySelector('[data-hn-analyzer-remove]');
            if (removeBtn) {
                removeBtn.hidden = items.length <= 2;
            }
        });
        if (addBtn) {
            addBtn.hidden = items.length >= maxItems;
        }
    }

    function renderError(message) {
        if (resultsEl) {
            resultsEl.hidden = false;
            resultsEl.innerHTML = '<div class="hn-analyzer__error">' + escHtml(message) + '</div>';
        }
    }

    function renderResults(items) {
        let bestScore = -1;
        let bestIdx = -1;
        items.forEach((item, i) => {
            if (typeof item.score === 'number' && item.score > bestScore) {
                bestScore = item.score;
                bestIdx = i;
            }
        });
        // Przy remisie nikt nie dostaje korony. Wczesniej wygrywal wpisany pierwszy,
        // wiec narzedzie wygladalo na ustawione pod te karme, ktora akurat wklejono na starcie.
        const tiedCount = items.filter((it) => it.score === bestScore).length;
        if (tiedCount > 1) {
            bestIdx = -1;
        }

        let html = '<h2 class="hn-analyzer__results-title">Wyniki analizy</h2><div class="hn-analyzer__cards">';
        items.forEach((item, i) => {
            const grade = item.grade || { letter: '?', label: '', color: '#64748b' };
            const isWinner = i === bestIdx && items.length > 1;

            html += '<div class="hn-analyzer__card' + (isWinner ? ' is-winner' : '') + '">';
            if (isWinner) {
                html += '<span class="hn-analyzer__winner">Najlepszy wybór</span>';
            }
            html += '<div class="hn-analyzer__card-header">';
            html += '<div class="hn-analyzer__grade" style="background:' + escAttr(grade.color) + '">' +
                '<span class="hn-analyzer__grade-letter">' + escHtml(grade.letter) + '</span>' +
                '<span class="hn-analyzer__grade-score">' + escHtml(item.score) + '/10</span></div>';
            html += '<div><h3 class="hn-analyzer__card-title">' + escHtml(item.label) + '</h3>' +
                '<p class="hn-analyzer__card-grade">' + escHtml(grade.label) + '</p></div></div>';

            if (Array.isArray(item.pros) && item.pros.length) {
                html += '<div class="hn-analyzer__pros"><h4>Plusy</h4><ul>' +
                    item.pros.map((p) => '<li>' + escHtml(p) + '</li>').join('') + '</ul></div>';
            }
            if (Array.isArray(item.cons) && item.cons.length) {
                html += '<div class="hn-analyzer__cons"><h4>Minusy</h4><ul>' +
                    item.cons.map((c) => '<li>' + escHtml(c) + '</li>').join('') + '</ul></div>';
            }
            if (Array.isArray(item.top3) && item.top3.length) {
                html += '<div class="hn-analyzer__top3"><h4>Pierwsze składniki</h4><ol>' +
                    item.top3.map((t) => '<li>' + escHtml(t.name || t.raw || '') + '</li>').join('') + '</ol></div>';
            }
            html += '</div>';
        });
        html += '</div>';

        if (resultsEl) {
            resultsEl.hidden = false;
            resultsEl.innerHTML = html;
            resultsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    async function run() {
        const compositions = [];
        formsWrap.querySelectorAll('[data-hn-analyzer-form]').forEach((item, idx) => {
            const labelEl = item.querySelector('.hn-analyzer__form-label');
            const textEl = item.querySelector('.hn-analyzer__form-text');
            const text = textEl ? textEl.value.trim() : '';
            if (text) {
                compositions.push({
                    label: (labelEl && labelEl.value.trim()) || ('Karma ' + (idx + 1)),
                    text,
                });
            }
        });

        if (!compositions.length) {
            renderError('Wklej skład przynajmniej jednej karmy.');
            return;
        }

        if (resultsEl) {
            resultsEl.hidden = false;
            resultsEl.innerHTML = '<p>' + escHtml((CFG.labels && CFG.labels.analyzing) || 'Analizuję…') + '</p>';
        }
        if (runBtn) runBtn.disabled = true;

        try {
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-WP-Nonce': CFG.nonce || '' },
                body: JSON.stringify({ compositions }),
            });
            const data = await response.json();
            if (!response.ok || !Array.isArray(data) || !data.length) {
                renderError((data && data.message) || (CFG.labels && CFG.labels.error) || 'Błąd analizy');
            } else {
                renderResults(data);
            }
        } catch (error) {
            renderError((CFG.labels && CFG.labels.error) || 'Błąd połączenia');
        } finally {
            if (runBtn) runBtn.disabled = false;
        }
    }

    if (addBtn) {
        addBtn.addEventListener('click', () => {
            const items = formsWrap.querySelectorAll('[data-hn-analyzer-form]');
            if (items.length >= maxItems) {
                return;
            }
            const clone = items[items.length - 1].cloneNode(true);
            clone.dataset.idx = String(items.length);
            clone.querySelectorAll('input, textarea').forEach((field) => { field.value = ''; });
            formsWrap.appendChild(clone);
            syncControls();
        });
    }

    formsWrap.addEventListener('click', (event) => {
        const removeBtn = event.target.closest('[data-hn-analyzer-remove]');
        if (!removeBtn) {
            return;
        }
        const items = formsWrap.querySelectorAll('[data-hn-analyzer-form]');
        if (items.length <= 2) {
            return;
        }
        const item = removeBtn.closest('[data-hn-analyzer-form]');
        if (item) item.remove();
        syncControls();
    });

    if (runBtn) {
        runBtn.addEventListener('click', run);
    }

    syncControls();
}
